<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        class="mb-2"
        style="margin-right:0.5em;border-radius:8px;"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
        <v-container fluid style="margin-top:-20px">
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title v-if="tenant == 'sbpps'">Parent-Teacher Communication</v-toolbar-title>
                    <v-toolbar-title v-else>Student's Diary</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="4" md="4">
                        <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list"
                            item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint
                            @change="getLearnerCourse()" hint="Please Select Academic Year" />
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <p><v-icon color="error">*</v-icon><b>Child</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="child" :items="child_list"
                            item-text="learner" item-value="id" label="Child" outlined persistent-hint
                            @change="getLearnerCourse()" hint="Please Select Child" />
                    </v-col>
                    <!-- <v-col cols="12" sm="4" md="4">
                        <p><v-icon color="error">*</v-icon><b>Message Type</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="diary_message_type"
                            :items="diary_message_type_list" item-text="name" item-value="id" label="Message Type" outlined
                            persistent-hint hint="Please Select Message Type" />
                    </v-col> -->
                    <v-col col="12" sm="2" md="2" class="pt-6 mt-6" v-if="this.ay && this.child">
                        <!-- <v-btn color="warning" @click="getParentDairy()">Fetch</v-btn> -->
                    </v-col>
                </v-row>

                <v-row justify="center" dense v-if="child && ay">
                    <!-- <v-btn class="button" @click="dialog_compose_message = true" dense>Compose Message</v-btn> -->
                </v-row>
                <v-data-table v-if="course_offering_learner_list != ''" dense class="elevation-1 mytable"
                    :headers="headers_1" :items="course_offering_learner_list" :items-per-page="-1" fixed-header>
                    <template v-slot:[`item.diary`]="{ item }">
                        <!-- <v-icon color="blue" @click="showDairy(item)">mdi-eye</v-icon> -->
                        <v-icon color="blue" @click="showparentdiary(item)">mdi-eye</v-icon>
                    </template>
                    <template v-slot:[`item.comp_msg`]="{ item }">
                        <v-btn class="button" @click="comp_msg(item)" dense>Compose Message</v-btn>
                    </template>
                </v-data-table>
            </v-card>

            <v-dialog v-model="dialog_show_message" style="margin-top: 10%;" fullscreen hide-overlay
                transition="dialog-top-transition">
                <v-card class="mx-auto">
                    <v-card class="box">
                        <v-toolbar flat class="toolbar">
                            <v-toolbar-title>
                                Student`s Diary | AY:{{ cay }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn small class="mt-5 pt-0 button" @click="close()" dense>Close</v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-row dense justify="center">
                                <v-col cols="12" sm="4" md="4">
                                    <p><v-icon color="error">*</v-icon><b>Message Type</b></p>
                                    <v-autocomplete color="#0F2027" dense rounded required v-model="diary_message_type"
                                        :items="diary_message_type_list" item-text="name" item-value="id"
                                        label="Message Type" outlined persistent-hint
                                        hint="Please Select Message Type" />
                                </v-col>
                                <v-col class="mt-6 pt-5" cols="12" sm="4" md="4">
                                    <v-btn color="warning" @click="showSubjectDairy()">Fetch</v-btn>
                                </v-col>
                            </v-row>
                            <v-data-table v-if="diary_data!=''" dense class="elevation-1 mytable" :headers="headers"
                                :search="search" :items="diary_data" :items-per-page="-1" fixed-header>
                                <template v-slot:[`item.diarymessagetype`]="{ item }">
                                    <v-chip :color="getColor(item.diarymessagetype)">
                                        {{ item.diarymessagetype }}
                                    </v-chip>
                                </template>
                                <template v-slot:[`item.message`]="{ item }">
                                    <v-icon color="blue" @click="showDairy(item)">mdi-eye</v-icon>
                                </template>
                                <template v-slot:[`item.attachment`]="{ item }">
                                    <a v-if="item.attachment_file_name != null" target="_blank"
                                        :href="awspath + item.attachment_file_path + item.attachment_file_name"><v-icon>mdi-attachment</v-icon></a>
                                </template>
                                <template v-slot:[`item.url`]="{ item }">
                                    <a v-if="item.url" :href="item.url" target="_blank">{{ item.url }}</a>
                                    <span v-else>--</span>
                                </template>
                                <template v-slot:[`item.action`]="{ item }">
                                    <span v-if="item.diarymessagetype == 'Teacher to Parent'">
                                        --
                                    </span>
                                    <span v-else>
                                        <v-icon color="red" @click="deleteDairy(item)">mdi-trash-can</v-icon>
                                    </span>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                    <v-row justify="center" dense>
                        <!-- <v-btn class="mt-5 pt-0 button" @click="close()" dense>Close</v-btn> -->
                    </v-row>
                </v-card>
            </v-dialog>
            <v-dialog v-model="msg_dialog" v-if="msg_data != null" max-width="1200px">
                <v-card>
                    <v-toolbar flat class="toolbar">
                        <v-card-title> Subject - {{ msg_data.courseoffering }} | Message [{{ msg_data.diarymessagetype
                            }}] </v-card-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-card class="box">
                            <v-row justify="center">
                                <v-col sm="3" md="3"> Post date : <b>{{ msg_data.post_date }}</b> </v-col>
                                <v-col sm="3" md="3"> Faculty : <b>{{ msg_data.instructor }}</b> </v-col>
                                <v-col sm="3" md="3"> Student : <b>{{ msg_data.learner }}</b> </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col sm="3" md="3"> Standard : <b>{{ msg_data.learner_std }}</b> </v-col>
                                <v-col sm="3" md="3"> Div : <b>{{ msg_data.learner_div }}</b> </v-col>
                                <v-col sm="3" md="3"> Roll No : <b>{{ msg_data.learner_roll }}</b> </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col sm="3" md="3"> Course - <b>{{ msg_data.courseoffering }}</b> </v-col>
                                <v-col sm="3" md="3"></v-col>
                                <v-col sm="3" md="3"></v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col sm="9" md="9">
                                    Subject :
                                    <v-text-field style="font-weight: bold;" outlined v-model="msg_data.subject"
                                        variant="outlined" readonly></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row justify="center">
                                <v-col sm="9" md="9">
                                    Message :
                                    <v-textarea style="font-weight: bold;" outlined name="input-9-6"
                                        v-model="msg_data.msg" variant="outlined" readonly></v-textarea>
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col sm="9" md="9" v-if="msg_data.url">
                                    URL :
                                    <a :href="msg_data.url" target="_blank">{{ msg_data.url }}</a>
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col sm="3" md="3" v-if="msg_data.isread == true"> Read On : <b>{{ msg_data.read_date
                                        }}</b> </v-col>

                                <v-col sm="3" md="3" v-if="msg_data.attachment_file_name != null">
                                    Attachment : <a target="_blank"
                                        :href="awspath + msg_data.attachment_file_path + msg_data.attachment_file_name"><v-icon>mdi-attachment</v-icon></a>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-card-text>
                    <v-card-actions class="justify-center"><v-btn color="warning"
                            @click="msg_dialog = false">Close</v-btn></v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialog_compose_message" style="margin-top: 10%;" fullscreen hide-overlay
                transition="dialog-top-transition">
                <v-card class="mx-auto">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Compose Message</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark text
                                @click="dialog_compose_message = false"><v-icon>mdi-close</v-icon>Close</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <br />
                    <v-card-text>
                        <v-card class="box">
                            <v-row justify="center" dense>
                                <v-col cols="12" sm="5" md="5">
                                    <p><v-icon color="error">*</v-icon><b>Subject</b></p>
                                    <v-text-field outlined v-model="subject"
                                        label="Enter Message Subject"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row justify="center" dense>
                                <v-col cols="12" sm="5" md="5">
                                    <p><v-icon color="error">*</v-icon><b>Description</b></p>
                                    <v-textarea outlined name="input-7-4" v-model="description"
                                        label="Enter Message Description"></v-textarea>
                                </v-col>
                            </v-row>
                            <v-row justify="center" dense>
                                <v-col cols="12" sm="5" md="5">
                                    <p><b>URL</b></p>
                                    <v-text-field outlined v-model="url" label="Enter URL" placeholder="https://example.com"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row justify="center" dense v-if="child && ay && description && subject">
                                <v-btn class="mt-5 pt-0 button" @click="addDiary()" dense :loading="loader">Send</v-btn>
                            </v-row>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-container>
         <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Subject Diary Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/TeLFvQXK2tY?si=Hjc1mus3vIA2yUnB"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            dialog_compose_message: false,
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            loader: false,
            tenant: null,
            snackbar_msg: "",
            videoDialog:false,
            color: "",
            snackbar: false,
            overlay: false,
            awspath: null,
            ay_list: [],
            ay: "",
            child_list: [],
            child: null,
            aws_path: null,
            diary_message_type_list: [],
            diary_message_type: "",
            diary_data: [],
            search: "",
            msg_dialog: false,
            cay: null,
            description: "",
            loader: false,
            subject: "",
            url: "",
            msg_data: null,
            course_offering_learner_list: [],
            headers: [
                {
                    text: "Sr. No.",
                    align: "left",
                    sortable: false,
                    value: "srno",
                },
                {
                    text: "Post Date",
                    align: "left",
                    sortable: false,
                    value: "post_date",
                },
                {
                    text: "Message Type",
                    align: "left",
                    sortable: false,
                    value: "diarymessagetype",
                },
                {
                    text: "Subject",
                    align: "left",
                    sortable: false,
                    value: "subject",
                },
                {
                    text: "Message",
                    align: "left",
                    sortable: false,
                    value: "message",
                },
                {
                    text: "Attachment",
                    align: "left",
                    sortable: false,
                    value: "attachment",
                },
                {
                    text: "URL",
                    align: "left",
                    sortable: false,
                    value: "url",
                },
                {
                    text: "Read On",
                    align: "left",
                    sortable: false,
                    value: "read_date",
                },
                {
                    text: "Action",
                    align: "left",
                    sortable: false,
                    value: "action",
                },
            ],
            headers_1: [
                {
                    text: "Sr. No.",
                    align: "left",
                    sortable: false,
                    value: "srno",
                },
                {
                    text: "Std - Div",
                    align: "left",
                    sortable: false,
                    value: "std_div",
                },
                {
                    text: "Subject Teacher",
                    align: "left",
                    sortable: false,
                    value: "coff_inst",
                },
                {
                    text: "Subject",
                    align: "left",
                    sortable: false,
                    value: "subject",
                },
                {
                    text: "Diary",
                    align: "left",
                    sortable: false,
                    value: "diary",
                },
                {
                    text: "Compose Message",
                    align: "left",
                    sortable: false,
                    value: "comp_msg",
                },
            ],
            coff_inst_id: null,
            coff_id: null,
            dialog_show_message: false,
        }),
        created() {
            this.aws_path = localStorage.getItem("awspath");
        },
        methods: {
            comp_msg(item) {
                (this.coff_inst_id = item.coff_inst_id), (this.coff_id = item.coff_id), (this.dialog_compose_message = true);
            },
            close(){
                this.coff_inst_id = null,
                this.coff_id = null,
                this.diary_data = []
                this.dialog_show_message = false
            },
            showparentdiary(item) {
                (this.coff_inst_id = item.coff_inst_id), (this.coff_id = item.coff_id);
                this.dialog_show_message = true;
            },
            async showSubjectDairy() {
                 this.diary_data = []
                const data = {
                    learner: this.child,
                    ay: this.ay,
                    coff_id: this.coff_id,
                    msg_type: this.diary_message_type,
                };
                try {
                    const res = await axios.post("/dairy/getParentCourseDairy", data);
                    if (res.data.flag == "YES") {
                        this.diary_data = res.data.diary_data;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                } finally {
                }
            },
            async getLearnerCourse() {
                if (this.child == null) {
                    this.showSnackbar("red", "Please Select Child");
                    return;
                }
                this.course_offering_learner_list = [];
                const data = {
                    learner: this.child,
                    ay: this.ay,
                };
                try {
                    const res = await axios.post("/dairy/getLearnerCourse", data);
                    if (res.data.flag == "YES") {
                        this.course_offering_learner_list = res.data.course_offering_learner_list;
                        if (this.course_offering_learner_list.length == 0) {
                            this.showSnackbar("red", "0 Sujects Added for for selected student for selected academic year!!");
                        }
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                } finally {
                }
            },
            async addDiary() {
                let formData = new FormData();
                if (this.child == null || this.child == "") {
                    this.showSnackbar("red", "Please select Child...");
                    return;
                }
                formData.append("learners", this.child);
                formData.append("description", this.description);
                formData.append("subject", this.subject);
                formData.append("url", this.url);
                formData.append("ay", this.ay);
                formData.append("coff_id", this.coff_id);
                formData.append("coff_inst_id", this.coff_inst_id);
                formData.append("from", "PTT");
                this.overlay = true;
                this.loader = true;
                try {
                    const res = await axios.post("/dairy/addCourseDiary", formData);
                    if (res.data.flag == "YES") {
                        this.stud_list = res.data.stud_list;
                        this.diary_data = res.data.diary_data;
                        this.showSnackbar("green", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                    this.loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    console.log("bye...");
                    this.overlay = false;
                    (this.dialog_compose_message = false), (this.description = ""), (this.subject = ""), (this.coff_inst_id = null), (this.coff_id = null), (this.loader = false),(this.url = "");
                }
            },

            async showDairy(item) {
                const formdata = {
                    diary_id: item.dairy_id,
                };
                //call api if message id from parent
                if (item.diarymessagetype == "Teacher to Parent" && item.isread == false) {
                    this.overlay = true;
                    try {
                        const res = await axios.post("/dairy/readTeacherDairy", formdata);
                        if (res.data.flag == "YES") {
                            item.read_date = res.data.read_date;
                            item.isread = true;
                            this.showSnackbar("green", res.data.snackbar);
                            this.msg_data = item;
                            this.msg_dialog = true;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    } catch (err) {
                        console.log("err", err);
                        this.onerror(err);
                        this.overlay = false;
                    } finally {
                        console.log("bye...");
                        this.overlay = false;
                    }
                } else {
                    this.msg_data = item;
                    this.msg_dialog = true;
                }
            },
            getColor(diarymessagetype) {
                if (diarymessagetype == "Parent to School") return "#A1C2F1";
                else return "#E1AEFF";
            },
            async deleteDairy(item) {
                const formdata = {
                    dairy_id: item.dairy_id,
                };
                this.overlay = true;
                try {
                    const res = await axios.post("/dairy/deleteParentDairy", formdata);
                    if (res.data.flag == "YES") {
                        var index = this.diary_data.indexOf(item);
                        this.diary_data.splice(index, 1);
                        this.showSnackbar("green", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    console.log("bye...");
                    this.overlay = false;
                }
            },
            onLoad() {
                axios
                    .post("Dairy/getStudentDiary")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
                            this.child_list = res.data.learner_list;
                            //this.child = this.child_list[0];
                            this.diary_message_type_list = res.data.diary_message_type_ptt_ttp_list;
                            this.diary_message_type = this.diary_message_type_list[0].id;
                            this.overlay = false;
                            // this.ay = res.data.curreny_ay;
                            this.cay = res.data.cay;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },

        mounted() {
            this.onLoad();
            this.tenant = localStorage.getItem("EPS-tenant");
        },
        created() {
            this.awspath = localStorage.getItem("awspath");
        },
        watch: {},
    };
</script>
<style scoped>
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }

    sub-row {
        border: 2px solid #424093;
        margin: 1rem;
        border-radius: 5px;
    }

    i {
        font-size: 20px !important;
    }

    .v-card__title {
        border: 1px solid #80808040;
        font-weight: bold;
        background-color: #424093;
        color: white;
        text-align: center;
        /* margin-top: 1.5rem; */
    }

    .card-border {
        border: 2px solid darkblue;
        border-radius: 10px;
        /* padding: 5px; */
        /* margin: 1rem !important; */
        width: auto;
    }

    .tx-bold {
        font-weight: bold;
        font-size: 14px;
        color: black;
    }

    i {
        font-size: 26px;
        cursor: pointer;
    }

    theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background-color: #424093 !important;
        color: white !important;
        margin-top: 2.35rem;
        border-radius: 20px;
    }

    /*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
    background-color: orange !important;
    color: black !important;
} */

    @media only screen and (max-width: 600px) {
    }

    .imgs {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: 150px;
        cursor: zoom-in;
    }

    .imgs-preview {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: auto;
    }

    v-simple-table {
        border-collapse: collapse;
        border-spacing: 0;
        width: auto;
        border: 1px solid #ddd;
    }

    th {
        color: white;
        font-weight: bold;
        text-align: center !important;
    }

    td,
    th {
        padding: 6px;
        border: 1px solid #ccc;
        text-align: center;
    }

    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }

    @media all and (min-width: 1000px) {
        .padding-metting {
            padding-right: 22px;
        }
    }

    @media (min-width: 320px) and (max-width: 350px) {
        .padding-bot {
            font-size: 11.6px;
        }
    }

    @media (min-width: 1000px) and (max-width: 1050px) {
        .padding-bot {
            font-size: 9.6px;
        }
    }

    .slide {
        color: red;
        font-weight: bold;
        margin-left: 10px;
    }

    .note-list {
        background-color: orange;
    }
</style>
